export default __webpack_public_path__ + "static/media/win_three.5a683b11.svg";